import * as React from 'react'

const NoResultsFoundIcon = () => (
   <svg width={106} height={106} fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx={49.534} cy={53.924} r={37.895} fill='#EAEEF9' />
      <path
         d='M92.14 38.286a3.246 3.246 0 1 0 0-6.493 3.246 3.246 0 0 0 0 6.493ZM96.89 25.617a2.217 2.217 0 1 0 0-4.434 2.217 2.217 0 0 0 0 4.434ZM16.17 22.014a4.117 4.117 0 1 0 0-8.234 4.117 4.117 0 0 0 0 8.234Z'
         fill='#EAEEF9'
      />
      <path
         d='M64.185 33.277H43.998v-7.66h26.608c4.134.097 7.49 3.512 7.49 7.66h-8.755'
         fill='#CCD4E2'
      />
      <g filter='url(#a)'>
         <path
            d='M71.192 25.616c-1.557.098-3.016.732-4.038 1.806a2.12 2.12 0 0 0-.292.341c-.924 1.074-1.605 2.489-1.605 4.001V77.34A7.63 7.63 0 0 1 57.62 85H20.458V31.423c.097-1.562.68-2.977 1.702-4.001a6.053 6.053 0 0 1 4.33-1.806H71.191Z'
            fill='url(#b)'
         />
      </g>
      <path
         d='M57.862 36.059H46.82a.75.75 0 0 1-.73-.732c0-.39.34-.732.73-.732h11.042c.389 0 .73.341.73.732 0 .39-.292.732-.73.732ZM41.618 36.059H27.22a.75.75 0 0 1-.73-.732c0-.39.34-.732.73-.732h14.447c.389 0 .73.341.73.732 0 .39-.341.732-.779.732ZM50.857 43.28h-14.35a.75.75 0 0 1-.729-.732c0-.39.34-.732.73-.732h14.35c.388 0 .729.342.729.732.048.39-.292.732-.73.732Z'
         fill='#B3BFD3'
      />
      <path
         d='M31.89 43.28h-4.67a.75.75 0 0 1-.73-.732c0-.39.34-.732.73-.732h4.67c.389 0 .73.342.73.732a.75.75 0 0 1-.73.732ZM57.866 50.502h-8.804a.75.75 0 0 1-.73-.732c0-.39.34-.732.73-.732h8.804c.389 0 .73.342.73.732 0 .39-.292.732-.73.732Z'
         fill='#D4DBEC'
      />
      <path
         d='M44.828 50.502H27.22a.75.75 0 0 1-.73-.732c0-.39.34-.732.73-.732h17.608c.39 0 .73.342.73.732 0 .39-.292.732-.73.732ZM50.864 57.723h-9.68a.75.75 0 0 1-.73-.732c0-.39.34-.732.73-.732h9.68c.389 0 .73.342.73.732.048.39-.293.732-.73.732Z'
         fill='#B3BFD3'
      />
      <path
         d='M36.948 57.723H27.22a.75.75 0 0 1-.73-.732c0-.39.34-.732.73-.732h9.777c.39 0 .73.342.73.732 0 .39-.34.732-.779.732Z'
         fill='#D4DBEC'
      />
      <path
         d='M57.865 64.945h-6.762a.75.75 0 0 1-.73-.732c0-.39.341-.732.73-.732h6.762c.389 0 .73.342.73.732 0 .39-.292.732-.73.732Z'
         fill='#B3BFD3'
      />
      <path
         d='M46.724 64.945H35.39a.75.75 0 0 1-.73-.732c0-.39.341-.732.73-.732h11.334c.389 0 .73.342.73.732a.75.75 0 0 1-.73.732Z'
         fill='#D4DBEC'
      />
      <path
         d='M31.16 64.945h-3.94a.75.75 0 0 1-.73-.732c0-.39.34-.732.73-.732h3.94c.389 0 .73.342.73.732a.75.75 0 0 1-.73.732ZM50.859 72.168h-6.713a.75.75 0 0 1-.73-.732c0-.39.341-.731.73-.731h6.713c.39 0 .73.341.73.731.048.39-.292.732-.73.732Z'
         fill='#B3BFD3'
      />
      <path
         d='M39.72 72.168h-12.5a.75.75 0 0 1-.73-.732c0-.39.34-.731.73-.731h12.5c.39 0 .73.341.73.731a.75.75 0 0 1-.73.732Z'
         fill='#D4DBEC'
      />
      <path
         d='M41.276 78.95h9.826c0 1.66.681 3.172 1.751 4.245 1.07 1.123 2.578 1.757 4.232 1.757H12.87a5.984 5.984 0 0 1-5.984-6.002h29.088s5.4.049 5.303 0Z'
         fill='#CCD4E2'
      />
      <path
         d='m83.46 74.278-6.14-6.137 1.407-1.408 6.137 6.142-1.403 1.403Z'
         fill='#858B9B'
      />
      <path
         d='m85.597 76.438-4.71-4.71a1.011 1.011 0 0 1 0-1.427 1.01 1.01 0 0 1 1.428 0l4.709 4.71a1.011 1.011 0 0 1 0 1.427 1.011 1.011 0 0 1-1.427 0Z'
         fill='#858B9B'
      />
      <path
         d='m85.258 76.738-6.06-6.059a.366.366 0 0 1 0-.514l1.55-1.55c.14-.14.368-.14.514 0l6.06 6.06c.14.14.14.369 0 .515l-1.55 1.548a.366.366 0 0 1-.514 0Z'
         fill='url(#c)'
      />
      <path
         d='M70.367 48.367c-6.429 0-11.638 5.21-11.638 11.637 0 6.423 5.21 11.638 11.633 11.638 6.428 0 11.637-5.21 11.637-11.638s-5.21-11.637-11.632-11.637Zm0 21.12c-5.161 0-9.342-4.25-9.342-9.488 0-5.238 4.18-9.482 9.342-9.482 5.16 0 9.34 4.249 9.34 9.487 0 5.239-4.184 9.482-9.34 9.482Z'
         fill='url(#d)'
      />
      <defs>
         <linearGradient
            id='b'
            x1={45.808}
            y1={24.243}
            x2={45.808}
            y2={85.64}
            gradientUnits='userSpaceOnUse'
         >
            <stop stopColor='#FDFEFF' />
            <stop offset={0.996} stopColor='#ECF0F5' />
         </linearGradient>
         <linearGradient
            id='c'
            x1={79.089}
            y1={72.678}
            x2={87.428}
            y2={72.678}
            gradientUnits='userSpaceOnUse'
         >
            <stop stopColor='#B0BACC' />
            <stop offset={1} stopColor='#969EAE' />
         </linearGradient>
         <linearGradient
            id='d'
            x1={58.718}
            y1={60.007}
            x2={82.003}
            y2={60.007}
            gradientUnits='userSpaceOnUse'
         >
            <stop stopColor='#B0BACC' />
            <stop offset={1} stopColor='#969EAE' />
         </linearGradient>
         <filter
            id='a'
            x={8.195}
            y={19.485}
            width={75.26}
            height={83.91}
            filterUnits='userSpaceOnUse'
            colorInterpolationFilters='sRGB'
         >
            <feFlood floodOpacity={0} result='BackgroundImageFix' />
            <feColorMatrix
               in='SourceAlpha'
               values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
               result='hardAlpha'
            />
            <feOffset dy={6.132} />
            <feGaussianBlur stdDeviation={6.132} />
            <feColorMatrix values='0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0' />
            <feBlend
               in2='BackgroundImageFix'
               result='effect1_dropShadow_8684_2289'
            />
            <feBlend
               in='SourceGraphic'
               in2='effect1_dropShadow_8684_2289'
               result='shape'
            />
         </filter>
      </defs>
   </svg>
)

export default NoResultsFoundIcon
